import Globals from './Globals'

const HEARTBEAT_INTERVAL = 5 * 60 * 1000; // 5 minutes
const STORAGE_KEY = 'expo.heartbeat.clientId';

let intervalId = null;
let interacted = false;

function onInteraction() {
    interacted = true;
}

function getClientId() {
    let id = localStorage.getItem(STORAGE_KEY);
    if (!id) {
        id = crypto.randomUUID ? crypto.randomUUID() :
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        localStorage.setItem(STORAGE_KEY, id);
    }
    return id;
}

function getClientType() {
    if (Globals.instance().electron) return 'desktop';
    if (Globals.instance().ipad || Globals.instance().ios) {
        if (Globals.instance().controllerApp) return 'ipad_controller';
        return 'ipad';
    }
    return 'web';
}

function getStatus() {
    if (Globals.instance().controllerApp) {
        return Globals.instance().nid ? 'controlling' : 'idle';
    }
    if (Globals.instance().presentationMode || Globals.instance().nid) return 'presenting';
    return 'idle';
}

function sendHeartbeat() {
    if (Globals.instance().noInternet) return;

    var apiBase = Globals.instance().adminAPI;
    if (!apiBase) return;

    var userObj = null;
    try { userObj = JSON.parse(localStorage.getItem('user')); } catch(e) {}
    var token = userObj ? userObj.token : null;

    if (!token) return;

    var headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = 'Token ' + token;

    var body = {
        client_id: getClientId(),
        client_type: getClientType(),
        version: Globals.instance().build,
        status: getStatus(),
        narrative_id: Globals.instance().nid || null,
        interaction: interacted,
    };
    interacted = false;

    fetch(apiBase + '/api/core/heartbeat/', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
    }).then(function() {
        console.log('Heartbeat sent');
    }).catch(function(err) {
        console.warn('Heartbeat failed', err);
    });
}

export function startHeartbeat() {
    if (intervalId) return;
    document.addEventListener('click', onInteraction, { passive: true });
    document.addEventListener('touchstart', onInteraction, { passive: true });
    document.addEventListener('keydown', onInteraction, { passive: true });
    sendHeartbeat();
    intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
}

export default { startHeartbeat };
